<template>
    <div>
        <b-card :title="$t('miniCurriculum.languages')">
            <b-row>
                <b-col md="12" xl="12" sm="12">
                    <b-button
                        v-if="isCurrentUserOrAdminOrLocalAdmin"
                        class="mb-4 float-right"
                        variant="primary"
                        size="sm"
                        @click="onClickNewLanguage"
                    >
                        {{ $t('miniCurriculum.form.buttons.addLanguage') }}
                    </b-button>
                </b-col>
            </b-row>

            <template v-if="!languages.length && isHidden">
                <b-alert show variant="info">
                    {{ $t('miniCurriculum.form.languageNotFound') }}
                </b-alert>
            </template>

            <div v-for="obj in languages" :key="obj.id">
                <b-row>
                    <b-col md="6" xl="6" sm="6">
                        <label for="language">{{
                            $t('miniCurriculum.form.label.language')
                        }}</label>
                        <b-form-input
                            class="mb-2"
                            :value="obj.language || '-'"
                            disabled
                        />
                    </b-col>

                    <b-col md="6" xl="6" sm="6">
                        <label for="proficiency">{{
                            $t('miniCurriculum.form.label.proficiency')
                        }}</label>
                        <b-form-input
                            class="mb-2"
                            :value="obj.proficiency || '-'"
                            disabled
                        />
                    </b-col>

                    <b-col md="12" xl="12" sm="12" v-if="obj.other_languages">
                        <label for="other_languages">{{
                            $t('miniCurriculum.form.label.other_languages')
                        }}</label>
                        <b-form-input
                            class="mb-2"
                            :value.sync="obj.other_languages"
                            disabled
                        />
                    </b-col>
                </b-row>

                <b-media right-align vertical-align="center">
                    <div slot="aside">
                        <b-dropdown
                            v-if="isCurrentUserOrAdminOrLocalAdmin"
                            :no-caret="true"
                            :dropleft="true"
                            :text="$t('form.button.edit')"
                            variant="outline-primary btn-outline-primary"
                            size="sm"
                            class="ml-1"
                        >
                            <b-dropdown-item
                                @click="onClickEditLanguage(obj.id)"
                            >
                                {{ $t('form.button.edit') }}
                            </b-dropdown-item>
                            <b-dropdown-item @click="handleDelete(obj.id)">
                                {{ $t('form.button.delete') }}
                            </b-dropdown-item>
                        </b-dropdown>
                    </div>
                </b-media>
            </div>
        </b-card>
    </div>
</template>

<script>
import api from '@/services/api'
import Swal from 'sweetalert2'
import i18n from '@/i18n'
import notification, { success } from '@/lib/notification'

notification.init()

export default {
    name: 'LanguageFormView',
    props: ['isCurrentUserOrAdminOrLocalAdmin', 'userId'],
    data() {
        return {
            languages: {},
            isHidden: false,
        }
    },
    mounted() {
        this.getLanguages()
    },
    methods: {
        getLanguages() {
            api.get(`users/${this.userId}/profile/languages`)
                .then(resp => {
                    const {
                        data: { data },
                    } = resp
                    this.languages = data
                })
                .finally(() => {
                    this.isHidden = true
                    this.$emit('ready')
                })
        },
        onClickNewLanguage() {
            return this.$router.push('/v2/mini-curriculum/languages/new')
        },
        onClickEditLanguage(id) {
            return this.$router.push(`/v2/mini-curriculum/languages/${id}/edit`)
        },
        handleDelete(id) {
            Swal({
                type: 'warning',
                title: i18n.t('notification.areYouSure'),
                confirmButtonText: i18n.t('notification.yes'),
                cancelButtonText: i18n.t('notification.no'),
                showCancelButton: true,
                showLoaderOnConfirm: true,
                preConfirm: () => {
                    api.delete(`/languages/${id}`).then(() => {
                        success(
                            i18n.t('notification.deletedSuccessfully', {
                                item: i18n.t('miniCurriculum.languages'),
                            })
                        )
                        this.getLanguages()
                    })
                },
            })
        },
    },
}
</script>
